export default __webpack_public_path__ + "static/media/brokenLink.9b7d088b.svg";